module.exports = __webpack_public_path__ + "img/cannon-damage.5e9308a7.png";